import React, { ComponentType, memo } from 'react'
import { TIconComponent } from 'transfix-icons/types'
import { ICommonProps } from 'transfix-ui/components/SvgIcon/types'
import { Box, Typography, Variant } from 'transfix-ui/core'
import { getBrandColor, TBrandColor } from 'transfix-ui'

interface IIconWithStatusProps {
  /**
   * @example ShieldFilled
   */
  icon: ComponentType<ICommonProps> | TIconComponent
  text: string
  /**
   * @example 'skyBlue6'
   */
  color: TBrandColor
  /**
   * @example 'body1'
   */
  textVariant?: Variant
}

/**
 * @example <IconWithStatus icon={ShieldFilled} color='warning' text='This carrier is bad' />
 */
const IconWithStatus = memo<IIconWithStatusProps>(
  ({ color: colorProp, icon: IconComponent, text, textVariant = 'body1' }) => {
    const color = getBrandColor(colorProp).hex()
    return (
      <Box display='flex' data-test='icon-with-status'>
        <Box flex='0 0 auto' pr={1} style={{ color }}>
          <IconComponent size='large' />
        </Box>
        <Box flex='1 1 auto'>
          <Typography variant={textVariant} component='span' style={{ color }}>
            {text}
          </Typography>
        </Box>
      </Box>
    )
  }
)

export default IconWithStatus
